/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export class ComparePropVolRptRequest {
  geographyFlag: number;
  workingScenId: number;
  workingScenName: string;
  compareScenId: number;
  compareScenName: string;
  workingPropScenId: number;
  workingPropScenName: string;
  comparePropScenId: number;
  comparePropScenName: string;
  startYear: number;
  endYear: number;
  geography: string;
  brands: string;
  prgmCodes: string;
  rptType: number;
  isGlobal: boolean;
}
